import { Injectable } from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';
const regexp_puntos_guiones = new RegExp(/[.-]/g);
const regexp_mascara_rut_ocho_caracteres = new RegExp(/^(\d{1,2})(\d{3})(\d{3})(\w{1})$/);
const regexp_mascara_rut_siete_caracteres = new RegExp(/^(\d{3})(\d{3})(\w{1})$/);

@Injectable()


export class ValidadoresService {

    constructor() {

    }

    _desenmascaraRutyQuitaDV(rut:string):string
    {
        let rut_modificado;
        rut_modificado = rut.replace(regexp_puntos_guiones, "");
        return rut_modificado.substring(0, String(rut_modificado).length - 1)
    }

    _enmascaraRut(rut: string): string {

        let val_rut_con_DV: string = "";
        let val_rut_sin_guion:string="";


        val_rut_con_DV = String(rut).concat("-").concat(this.devuelveDV(Number(rut)));

        if (val_rut_con_DV.length < 7) {
            val_rut_con_DV = "";
        }
        else {
            if (val_rut_con_DV.length > 0) {
                if (val_rut_con_DV.indexOf('-') > 0) {

                }
                else {
                    val_rut_con_DV = val_rut_con_DV.substring(0, val_rut_con_DV.length - 1).concat("-").concat(val_rut_con_DV.substring(val_rut_con_DV.length - 1))
                    //val = "";
                }
                val_rut_sin_guion = val_rut_con_DV.replace(regexp_puntos_guiones, '');
                if (val_rut_sin_guion.length >= 8)
                {
                    val_rut_con_DV = val_rut_con_DV.replace(regexp_puntos_guiones, '').replace(regexp_mascara_rut_ocho_caracteres, '$1.$2.$3-$4');
                }
                else
                {
                    val_rut_con_DV = val_rut_con_DV.replace(regexp_puntos_guiones, '').replace(regexp_mascara_rut_siete_caracteres, '$1.$2-$3');
                }



            }
        }

        return val_rut_con_DV;
    }

    _mascaraRut(event: any) {
        let valor_rut: string = "";
        let largo_minimo_rut: number = 7;

        valor_rut = event.target.value;

        if (valor_rut.length < largo_minimo_rut) {
            valor_rut = "";
        }
        else {
            valor_rut = valor_rut.replace(regexp_puntos_guiones, '');

            if (valor_rut.length >= 8) {
                if (!(valor_rut.indexOf('-') > 0)) {
                    //valor_rut = valor_rut.substring(0, valor_rut.length - 1).concat("-").concat(valor_rut.substring(valor_rut.length - 1))
                    //val = "";
                }
                valor_rut = valor_rut.replace(regexp_mascara_rut_ocho_caracteres, '$1.$2.$3-$4');

            }
            else {
                valor_rut = valor_rut.replace(regexp_mascara_rut_siete_caracteres, '$1.$2-$3')

            }
        }

        event.target.value = valor_rut;
        return valor_rut;
    }
    private static esPatente(patente: string) {

        if (isNaN(Number(patente.split('-')[1]))) {
            return false;
        }
        else {
            if (Number(patente.split('-')[1]) < 9) {
                return false;
            }
            else {
                if (patente.split('-')[0].length == 4) {
                    //4 caracteres = patente nueva
                    if (patente.split('-')[1].length == 2) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else if (patente.split('-')[0].length == 2) {
                    //2 caracteres = patente vieja
                    if (patente.split('-')[1].length == 4) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }

            }
        }

    }

    private static digitoValido(dv: String) {
        if (dv != '0' && dv != '1' && dv != '2' && dv != '3' && dv != '4' && dv != '5' && dv != '6' && dv != '7' && dv != '8' && dv != '9' && dv != 'k' && dv != 'K') {
            return false;
        }
        return true;
    }

    private static quitarFormato(rut: String) {
        var strRut = new String(rut);
        while (strRut.indexOf(".") != -1) {
            strRut = strRut.replace(".", "");
        }
        while (strRut.indexOf("-") != -1) {
            strRut = strRut.replace("-", "");
        }
        return strRut;
    }

    private static getDigito(rut) {
        var dvr = '0';
        let suma: number;
        let mul: number;
        suma = 0;
        mul = 2;
        let i: number;
        let res: number;
        for (i = rut.length - 1; i >= 0; i--) {
            suma = suma + rut.charAt(i) * mul;
            if (mul == 7) {
                mul = 2;
            } else {
                mul++;
            }
        }
        res = suma % 11;
        if (res == 1) {
            return 'k';
        } else if (res == 0) {
            return '0';
        } else {
            return 11 - res;
        }
    }

    private static digitoCorrecto(crut: String) {
        let largo: number;
        let rut: String;
        let dvr: String;
        let dv: String;
        largo = crut.length;
        if (largo < 2) {
            return false;
        }
        if (largo > 2) {
            rut = crut.substring(0, largo - 1);
        } else {
            rut = crut.charAt(0);
        }
        dv = crut.charAt(largo - 1);
        this.digitoValido(dv);
        if (rut == null || dv == null) {
            return 0;
        }
        dvr = this.getDigito(rut).toString();
        if (dvr != dv.toLowerCase()) {
            return false;
        }
        return true;
    }

    private static validarrut(texto: String) {
        texto = ValidadoresService.quitarFormato(texto);
        let largo: number;
        largo = texto.length;
        let rutFormateado = "";
        // rut muy corto
        if (largo < 2) {
            return false;
        }
        let i: number;
        // verifica que los numeros correspondan a los de rut
        for (i = 0; i < largo; i++) {
            // numero o letra que no corresponda a los del rut
            if (!this.digitoValido(texto.charAt(i))) {
                return false;
            }
        }
        var invertido = "";
        let j: number;
        for (i = (largo - 1), j = 0; i >= 0; i--, j++) {
            invertido = invertido + texto.charAt(i);
        }
        var dtexto = "";
        dtexto = dtexto + invertido.charAt(0);
        dtexto = dtexto + '-';
        let cnt: number;
        cnt = 0;
        for (i = 1, j = 2; i < largo; i++, j++) {
            if (cnt == 3) {
                dtexto = dtexto + '.';
                j++;
                dtexto = dtexto + invertido.charAt(i);
                cnt = 1;
            } else {
                dtexto = dtexto + invertido.charAt(i);
                cnt++;
            }
        }
        invertido = "";
        for (i = (dtexto.length - 1), j = 0; i >= 0; i--, j++) {
            invertido = invertido + dtexto.charAt(i);
        }
        rutFormateado = invertido;
        //alert($scope.rutV);
        //return invertido;
        //console.log(invertido);
        if (this.digitoCorrecto(texto)) {
            return true;
        }
        return false;
    }

    ValidaFormatoRut(inputRut: FormControl): ValidationErrors {
        if (String(inputRut.value).length < 7) {
            return { ValidaFormatoRut: true }
        }

        if (ValidadoresService.validarrut((String(inputRut.value)))) {
            return null;
        }
        else {
            return { ValidaFormatoRut: true }
        }
    }

    ValidaFormatoPatente(inputPatente: FormControl): ValidationErrors {
        if (String(inputPatente.value).indexOf("-") > 0) {
            if (ValidadoresService.esPatente(inputPatente.value)) {
                return null;
            }
            else {
                return { ValidaFormatoPatente: true }
            }

        }
        else {
            return { ValidaFormatoPatente: true }
        }




    }

    devuelveDV(rut: Number): string {
        return String(ValidadoresService.getDigito(rut.toString()));
    }


}
